import { Component } from '@theme/component';

/**
 * A custom element that formats rte content for easier styling
 */
class RTEFormatter extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.#formatTables();
    this.tableObserver = new MutationObserver(() => this.#formatTables());
    this.tableObserver.observe(this, { childList: true, subtree: true });
  }

  disconnectedCallback() {
    this.tableObserver?.disconnect();
    super.disconnectedCallback();
  }

  #formatTables() {
    this.querySelectorAll('table').forEach((table) => this.#formatTable(table));
  }

  /**
   * Formats a table for easier styling
  * @param {HTMLTableElement} table
  */
  #formatTable(table) {
    const headers = Array.from(table.querySelectorAll('thead th')).map((header) => header.textContent.trim());

    if (headers.length) {
      table.querySelectorAll('tbody tr').forEach((row) => {
        row.querySelectorAll(':scope > th, :scope > td').forEach((cell, index) => {
          if (headers[index]) {
            cell.setAttribute('data-label', headers[index]);
          }
        });
      });
    }

    if (table.parentElement?.classList.contains('rte-table-wrapper')) return;

    const wrapper = document.createElement('div');
    wrapper.classList.add('rte-table-wrapper');
    const parent = table.parentNode;
    if (parent) {
      parent.insertBefore(wrapper, table);
      wrapper.appendChild(table);
    }
  }
}

if (!customElements.get('rte-formatter')) {
  customElements.define('rte-formatter', RTEFormatter);
}
